<template>
  <div>
    <div
      v-if="domeinlijsten.length > 0"
      class="my-4 mx-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 grid-flow-row gap-4"
    >
      <DomeinlijstCard
        v-for="domeinlijst in domeinlijsten"
        :key="domeinlijst.id"
        :domeinlijst="domeinlijst"
        :domeinlijstitems="domeinlijsten"
      />

      <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
        <div
          class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-300 rounded-t-lg text-gray-100 truncate"
        >
          Toevoegen
        </div>
        <FormulateForm
          v-model="domeinlijst_data"
          class="m-2"
          @submit="addDomeinlijst"
          name="add_domeinlijst"
        >
          <FormulateInput
            name="naam"
            type="text"
            label="Naam"
            validation="required|isUniqueName"
            :validation-messages="{
              required: 'Verplicht veld.',
              isUniqueName: 'Naam bestaat al.'
            }"
            :validation-rules="{ isUniqueName }"
          />
          <FormulateInput
            name="code"
            type="text"
            label="Code"
            validation="required|isUniqueCode|matches:/^[a-zA-Z0-9_-]+$/"
            :validation-messages="{
              required: 'Verplicht veld.',
              matches:
                'Mag alleen uit getallen en/of letters of _ of - bestaan',
              isUniqueCode: 'Code bestaat al.'
            }"
            :validation-rules="{ isUniqueCode }"
          />
          <FormulateInput
            name="omschrijving"
            type="textarea"
            label="Omschrijving"
            validation="required"
            :validation-messages="{ required: 'Verplicht veld.' }"
          />
          <FormulateInput
            type="submit"
            label="Toevoegen"
            input-class="ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded hover:bg-mi-blue-400 hover:text-white hover:border-transparent;"
          />
        </FormulateForm>
        <p class="m-2">{{ msg }}</p>
      </div>
    </div>
    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>
  </div>
</template>

<script>
import { sortByAttr } from "../../common/utils.js";
import DomeinlijstCard from "./DomeinlijstCard";
export default {
  components: {
    DomeinlijstCard
  },
  data() {
    return {
      msg: null,
      domeinlijst_data: null
    };
  },
  computed: {
    domeinlijsten() {
      if (!this.$store.state.backend_data_loaded) return [];
      return sortByAttr(
        this.$store.state.backend_data[
          this.mapUrlPartToInternalName(this.$route.params.name)
        ],
        "naam"
      );
    },
    domeinlijst_names() {
      return this.domeinlijsten.map(item => item.naam);
    },
    domeinlijst_codes() {
      return this.domeinlijsten.map(item => item.code);
    }
  },
  methods: {
    hideMsg: function() {
      this.msg = null;
    },
    mapUrlPartToInternalName: name =>
      ({
        voorziening_typen: "services",
        ondergrond_typen: "substrates",
        sport_typen: "sports"
      }[name]),
    addDomeinlijst: async function() {
      const [ok, msg] = await this.$store.dispatch("addDomeinlijst", {
        name: this.$route.params.name.toLowerCase(),
        properties: this.domeinlijst_data
      });
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
        this.$formulate.reset("add_domeinlijst");
      } else {
        this.msg = msg;
      }
    },
    isUniqueName: function({ value }) {
      return !this.domeinlijst_names.includes(value);
    },
    isUniqueCode: function({ value }) {
      return !this.domeinlijst_codes.includes(value);
    }
  },
  watch: {
    msg() {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  }
};
</script>

<style></style>
